// extracted by mini-css-extract-plugin
export default {"emptyView":"EmptyView_emptyView__3L29u","illustration":"EmptyView_illustration__f7jMs","title":"EmptyView_title__tXPAK"};